import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { tokenNotExpired } from 'angular2-jwt';
import { AccountService } from '../../service/account/account.service';

import { WebService } from '../web.service';

@Injectable()
export class LoginCandidateService extends WebService {
    public user;

    loggedIn() {
      return tokenNotExpired();
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        localStorage.removeItem('permissions');
        this.refreshToken();
        this.router.navigateByUrl('/login');
    }

    logoutCandidate() {
        localStorage.removeItem('token');
        localStorage.removeItem('profile');
        localStorage.removeItem('permissions');
        this.refreshToken();
        this.router.navigateByUrl('/login-candidate');
    }

    login(body: Object): Observable<Response> {
        this.refreshToken();
        return this.http.post( `${this.apiUrl}/auth/login`, JSON.stringify(body), { headers: this.headers } );
    }

    passwordRecovery(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/auth/password_recovery`, JSON.stringify(body), { headers: this.headers } );
    }
  
    setUser(user) {
        this.user = user;
    }

    getRole(){
        if (JSON.parse(localStorage.getItem('profile')))
            return JSON.parse(localStorage.getItem('profile')).roles[0].name;//.id
        else
            this.logoutCandidate();
    }

    isCandidateUser() {
        let user = JSON.parse(localStorage.getItem('profile'));
        
        if (user) {
            if(user.candidate_id)
                return true;
            return false;
        } else{
            this.logout();
            return false;
        }  
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/login-candidate/login-candidate.service.ts